import React, { Component } from 'react';
import QueryString from 'query-string';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Paper,
} from '@material-ui/core';
import { Search, ArrowBack, Settings } from '@material-ui/icons';

import gif_img from './resources/loading.gif';
import img_error from './resources/error.png';
import img_setting from './resources/settings.png';
import img_back from './resources/back_a.png';

import PageNotFound from './PageNotFound';
import LoadingDialog from './dialog/LoadingDialog';
import ErrorDialog from './dialog/ErrorDialog';

var request = require('../utilities/NetworkRequest');
var cache_util = require('../utilities/CacheUtil');

var route_list = [
  'login',
  'gphome',
  'print',
  'print_mini',
  'print_rekap_order',
  'print_rekap_order_product',
  'print_mini_old',
  'print_delivery',
  'products_catalog',
  'print_product',
  'catalog_editor',
  'v2_wholesaler'
];

export default class Wholesaler extends Component {

  constructor(props) {
    super(props);
    this.m_filter = null;
    this.state = {
      is_main_loading: true,
      is_loading: false,
      is_error: false,
      error_message: '',
      is_filter: false,
      body_error: {
        is_show: false,
        message: ''
      },
      user_id: null,
      list_wholesaler: [],
      pagination: null,
      filter: [
        {
          type: 'input_free_text',
          key: 'a.wholesaler_name',
          value: ''
        }
      ]
    };
  }

  requestData() {
    try {
      let body = {}, temp_session;
      if (this.props.match.params.session === 'wholesaler') {
        temp_session = cache_util.onGetCacheString(cache_util.CACHE_SESSION);
        if (temp_session !== null) {
          body.session = temp_session;
        } else {
          throw Error('Belum ada session, silahkan login di https://www.tokopintar.co.id/');
        }
      } else {
        temp_session = QueryString.parse(this.props.location.search);
        body.session = temp_session.session;
      }
      request.onRequestData(request.OPTION_API_MAIN, '/show/wholesaler', body, res_data => {
        if (res_data.code === 1) {
          if (this.props.match.params.session !== 'wholesaler') {
            cache_util.onSaveCache(cache_util.CACHE_SESSION, body.session);
          }
          // CHECK IF RESULT IS ONLY ONE BY IT'S VERSION
          if (res_data.result.hasOwnProperty('wholesaler')) {
            this.setState({
              is_main_loading: false,
              user_id: res_data.result.user_id,
              list_wholesaler: res_data.result.wholesaler,
              pagination: res_data.result.pagination
            });
          } else {
            cache_util.onSaveCache(cache_util.CACHE_INFO, JSON.stringify(res_data));
            window.open(request.IP_PATH + '/gphome/dashboard?dt=' + new Date().getTime(), '_self');
          }
        } else {
          this.setState({
            is_main_loading: false,
            is_error: true,
            error_message: res_data.message
          });
        }
      });
    } catch (e) {
      this.setState({
        is_main_loading: false,
        is_error: true,
        error_message: e.message
      });
    }
  }

  requestHome(data) {
    this.setState({ is_loading: true }, () => {
      let body = {
        wholesaler_id: data.wholesaler_id,
        user_id: this.state.user_id === null ? undefined : this.state.user_id
      };
      let m_info = { result: { user_information: { wholesaler_id: data.wholesaler_id } } }
      cache_util.onSaveCache(cache_util.CACHE_INFO, JSON.stringify(m_info));
      request.onRequestData(request.OPTION_API_MAIN, '/show/home', body, res_data => {
        if (res_data.code === 1) {
          cache_util.onSaveCache(cache_util.CACHE_INFO, JSON.stringify(res_data));
          window.open(request.IP_PATH + '/gphome/dashboard?dt=' + new Date().getTime(), '_self');
        } else {
          this.setState({
            is_loading: false,
            body_error: {
              is_show: true,
              message: res_data.message
            }
          });
        }
      });
    });
  }

  getAdminStyle(data) {
    if (data.wholesaler_id !== 'TP9999') {
      return 'wholesaler_card custom_cursor_a';
    } else {
      return 'wholesaler_card custom_cursor_a green_linear_bg';
    }
  }

  getTitleStyle(data) {
    if (data.wholesaler_id !== 'TP9999') {
      return 'default_text_normal_gray_b bold_text';
    } else {
      return 'default_text_normal_white_b bold_text';
    }
  }

  getLabelStyle(data) {
    if (data.wholesaler_id !== 'TP9999') {
      return 'normal_margin_top_e default_text_normal_gray';
    } else {
      return 'normal_margin_top_e default_text_normal_white';
    }
  }

  getViewWholesaler(data) {
    let view = [];
    if (Object.keys(data).length === 0) {
      view.push(
        <Box display="flex" justifyContent="center" alignItems="center" height={100}>
          <Typography variant="body1" color="textSecondary">
            Tidak ada grosir yang ditemukan!
          </Typography>
        </Box>
      );
    } else {
      for (let i = 0; i < Object.keys(data).length; i++) {
        view.push(
          <Card
            key={i}
            onClick={this.requestHome.bind(this, data[i])}
            style={{
              marginBottom: 16,
              cursor: 'pointer',
              borderRadius: 8,
              boxShadow: '0px 3px 6px rgba(0,0,0,0.16), 0px 3px 6px rgba(0,0,0,0.23)'
            }}
            className={this.getAdminStyle(data[i])}
          >
            <CardContent style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={data[i].profile_img_url}
                alt=""
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  marginRight: 16,
                  objectFit: 'cover',
                }}
              />
              <div>
                <Typography variant="subtitle1" style={{ fontWeight: 600 }} className={this.getTitleStyle(data[i])}>
                  {data[i].wholesaler_name}
                </Typography>
                <Typography variant="body2" className={this.getLabelStyle(data[i])}>
                  {data[i].address}
                </Typography>
              </div>
            </CardContent>
          </Card>
        );
      }
    }
    return view;
  }

  trackScrolling(el) {
    let bottom_el = document.getElementById('bottom_nav');
    if (bottom_el.getBoundingClientRect().bottom <= window.innerHeight) {
      if (!this.state.is_loading && this.state.pagination.is_more) {
        this.requestMoreWholesaler(this.m_filter, true);
      }
    }
  }

  requestMoreWholesaler(filter, next) {
    this.setState({ is_loading: true }, () => {
      let body = {
        user_id: this.state.user_id,
        idx: this.state.pagination.last
      }
      if (filter !== null) { body.filter = filter; }
      if (!next) { delete body.idx; }
      request.onRequestData(request.OPTION_API_MAIN, '/show/wholesaler', body, res_data => {
        if (res_data.code === 1) {
          let temp_wholesaler = this.state.list_wholesaler;
          if (next) {
            temp_wholesaler = temp_wholesaler.concat(res_data.result.wholesaler);
          } else {
            temp_wholesaler = res_data.result.wholesaler;
          }
          this.setState({
            is_loading: false,
            list_wholesaler: temp_wholesaler,
            pagination: res_data.result.pagination
          });
        } else {
          this.setState({
            is_loading: false,
            body_error: {
              is_show: true,
              message: res_data.message
            }
          });
        }
      });
    })
  }

  onFilterClicked() {
    this.setState({ is_filter: true }, () => {
      this.m_filter = this.state.filter;
      this.requestMoreWholesaler(this.m_filter, false);
    });
  }

  onEditTextChanged(value) {
    let temp = this.state.filter;
    temp[0].value = value;
    this.setState({ filter: temp });
  }

  getResetFilter() {
    if (this.state.is_filter) {
      return (
        <div onClick={() => this.onResetFilter()} className='display_flex_center' style={{ cursor: 'pointer', width: 50 }}>
          <img src={img_back} alt='' />
        </div>
      );
    } else { return null; }
  }

  onResetFilter() {
    let temp = this.state.filter;
    temp[0].value = '';
    this.m_filter = null;
    this.setState({
      is_filter: false,
      filter: temp
    }, () => {
      this.requestMoreWholesaler(this.m_filter, false);
    });
  }

  getRootView() {
    if (this.state.is_main_loading) {
      this.requestData();
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100vh"
          bgcolor="#DB09AA"
        >
          <img src={gif_img} alt="" style={{ width: 80, height: 80 }} />
        </Box>
      );
    } else {
      if (!this.state.is_error) {
        return (
          <Box
            className="root_login"
            sx={{
              width: "100%",
              height: "100vh",
              backgroundColor: "#DB09AA", // warna utama
              backgroundImage: "url('/bg-cover.png')", // gambar background
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundBlendMode: "multiply", // atau "overlay", "screen", dll
            }}
          >
            <LoadingDialog showDialog={this.state.is_loading} />
            {this.showErrorDialog(this.state.body_error)}

            {/* Container putih */}
            <Paper
              elevation={3}
              style={{
                width: 440,
                maxHeight: '80%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 12,
                padding: 20,
                backgroundColor: '#fff',
              }}
            >
              {/* Title */}
              <Typography
                variant="h6"
                style={{ fontWeight: 600, marginBottom: 25, marginTop: 13, textAlign: 'center' }}
              >
                Pilih Grosir
              </Typography>

              {/* Filter */}
              <Box display="flex" alignItems="center" mb={2}>
                {this.state.is_filter && (
                  <IconButton onClick={() => this.onResetFilter()}>
                    <ArrowBack />
                  </IconButton>
                )}
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Ketik nama grosir disini..."
                  value={this.state.filter[0].value}
                  onChange={(event) => this.onEditTextChanged(event.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => this.onFilterClicked()}>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              {/* List grosir */}
              <Box
                style={{
                  overflowY: 'auto',
                  flex: 1,
                  paddingRight: 8,
                }}
              >
                {this.getViewWholesaler(this.state.list_wholesaler)}
                {this.state.is_loading && (
                  <Box display="flex" justifyContent="center" my={2}>
                    <CircularProgress size={28} />
                  </Box>
                )}
              </Box>
            </Paper>
          </Box>
        );
      } else {
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            width="100%"
            height="100vh"
            bgcolor="#DB09AA"
          >
            <img src={img_error} alt="" style={{ width: 100, marginBottom: 16 }} />
            <Typography variant="h6" color="textSecondary">
              {this.state.error_message}
            </Typography>
          </Box>
        );
      }
    }
  }

  showErrorDialog(body) {
    if (body.is_show) {
      return <ErrorDialog body_error={body} onCloseDialog={() => this.setState({ body_error: { is_show: false, message: '' } })} />
    } else {
      return null;
    }
  }

  render() {
    if (this.props.match.params.session === undefined) {
      // SHOW PAGE NOT FOUND
      return <PageNotFound />;
    } else {
      if (route_list.includes(this.props.match.params.session)) {
        let temp_session = cache_util.onGetCacheString(cache_util.CACHE_SESSION);
        if (temp_session === null) {
          return <PageNotFound />;
        } else {
          return null;
        }
      } else {
        return this.getRootView();
      }
    }
  }

}
